import { Link } from "react-router-dom";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";

export default function About() {
  return (
    <section className="relative py-24 lg:py-32 bg-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3]">
              <img
                src="https://images.unsplash.com/photo-1581094651181-35942459ef62?q=80&w=2940&auto=format&fit=crop"
                alt="Team collaboration"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent" />
            </div>
            
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 border border-gray-100 max-w-[220px]">
              <div className="text-sm font-semibold text-gray-900 mb-1">Built in Nigeria</div>
              <div className="text-sm text-gray-600">Serving businesses across Africa and beyond with cloud-native software</div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-full mb-6">
              <div className="w-1.5 h-1.5 rounded-full bg-[#0186ef]" />
              <span className="text-xs font-semibold text-[#0186ef] uppercase tracking-wider">About DevDesk</span>
            </div>

            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight mb-6">
              From Nigeria to a <span className="text-[#0186ef]">global</span> frontier
            </h2>

            <p className="text-lg text-gray-500 leading-relaxed mb-6">
              DevDesk is an innovative cloud-based integrated digital studio building 
              human capital software for businesses. We provide end-to-end services 
              that enable companies and brands accelerate business processes, manage 
              changes, and create effective networks that foster growth.
            </p>

            <p className="text-lg text-gray-500 leading-relaxed mb-8">
              Our strategic approach scales, systemizes, and sustains growth for 
              clients, from startups to established enterprises.
            </p>

            <Link
              to="/about"
              className="inline-flex items-center text-[#0186ef] font-semibold hover:text-[#0070d0] transition-colors group"
            >
              Learn more about us
              <ArrowLongRightIcon className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
